import { getEntity } from './_utils'

export const getOrganization = getEntity('organizations')
